
import Vue from "vue";
import { Company } from "@/models/company";
import { Dossier } from "@/models/dossier";
import AppDossierInfoForm from "./DossierInfoForm.vue";

export default Vue.extend({
	props: {
		value: {
			type: Object as () => Dossier,
			required: true
		},
		company: {
			type: Object as () => Company,
			required: true
		},
	},
	components: {
		AppDossierInfoForm
	}
});
